<div class="timesheet-grid timesheet-content-row" [ngStyle]="{ 'height.px': height }">
  <div class="timesheet__actions flex items-center gap-xs">
    <ng-content></ng-content>
    <button
      sb-icon-button
      *absenteePermission="absence; type: 'edit'"
      [color]="'transparent'"
      [attr.aria-label]="'Edit' | translate"
      [appAbsenceRequest]="{ absenceId: absence.id, action: 'edit', originator: 'timesheet' }"
    >
      <sb-icon name="pencil-regular" />
    </button>
  </div>
  @if (showTotals) {
    <div class="timesheet__totals">
      <ng-template #absenceTooltip>
        <ng-content select="[absence-tooltip]"></ng-content>
      </ng-template>
      <div class="timesheet-totals__time" [sbTooltip]="absenceTooltip" [sbTooltipPlacement]="'top'">
        {{ absence.periodHours | localeDuration: 'digital' }}
      </div>
      <ng-container *subscriptionPlan="planType.BASIC">
        @if (showSalary) {
          @let formattedPeriodPay = absence.periodPay | money;
          <div class="timesheet-totals__salary">
            <span class="timesheet-totals__value" [sbTooltip]="formattedPeriodPay">{{ formattedPeriodPay }}</span>
          </div>
          @if (showCoc) {
            @let formattedPeriodCoc = absence.periodCoc | money;
            <div class="timesheet-totals__salary">
              <span class="timesheet-totals__value" [sbTooltip]="formattedPeriodCoc">{{ formattedPeriodCoc }}</span>
            </div>
          }
        }
      </ng-container>
    </div>
  }
</div>
